import { MenuItem } from '../../../Menus';

import { OptionProps } from './Option.types';

export const Option = (props: OptionProps) => {
  return <MenuItem {...props} />;
};
